import React from 'react';

export const delay = (ms: number) => new Promise((res) => { setTimeout(res, ms); });

export const awaitWithMinimumDelay = <T = any>(
  promise: Promise<T>,
  ms: number,
): Promise<T> => {
  const startsAt = new Date();
  const waitDelay = async () : Promise<void> => {
    const endsAt = new Date();
    const diff = endsAt.getTime() - startsAt.getTime();
    if (diff >= ms) return;
    await delay(ms - diff);
  };
  const result = new Promise<T>((resolve, reject) => {
    promise.then(async (value : T) => {
      await waitDelay();
      resolve(value);
    }).catch(async (error : any) => {
      await waitDelay();
      reject(error);
    });
  });
  return result;
};

export const generateRandomId = (digit: number = 16): string => [...Array(16)].map(() => Math.floor(Math.random() * 16).toString(16)).join('');

export const cssPropertiesToStyledComponent = (dict: React.CSSProperties): string => {
  let str = '';
  Object.entries(dict).forEach((pair) => {
    const [key, value] = pair;
    let clo = '';
    key.split('').forEach((lt) => {
      if (lt.toUpperCase() === lt) {
        clo += `-${lt.toLowerCase()}`;
      } else {
        clo += lt;
      }
    });
    str += `${clo}:${value};`;
  });
  return str;
};

export const enumContainsString = (enu: any, str: string): boolean => (
  Object.values(enu).includes(str)
);

export const is24HourClockFormat = (): boolean => {
  const now = new Date();
  const dateStr = now.toLocaleTimeString();

  // apparently toLocaleTimeString() has a bug in Chrome. toString() however
  // returns 12/24 hour formats. If one of two contains AM/PM execute 12 hour
  // coding.
  if (dateStr.match(/am|pm/i) || dateStr.toString().match(/am|pm/i)) {
    return false;
  }
  return true;
};

export const isMobilePlatform = (): boolean => {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
  ];
  return toMatch.some((toMatchItem) => navigator.userAgent.match(toMatchItem));
};

export const isTouchEnabled = (): boolean => (
  ('ontouchstart' in window)
  || ((navigator as any).maxTouchPoints > 0)
  || ((navigator as any).msMaxTouchPoints > 0)
);

export const addToPathNameUrl = (url : string, suffixPathName : string) : string => {
  const urlObj = new URL(url);
  if (urlObj.pathname.endsWith('/') && suffixPathName.startsWith('/')) {
    suffixPathName = suffixPathName.replace('/', '');
  }
  urlObj.pathname += suffixPathName;
  return urlObj.href;
};

export const getDateDifferenceText = (start: Date, end: Date) => {
  let ms = end.getTime() - start.getTime();
  if (ms < 0) return '';
  const hours = Math.floor(ms / 3600000); // get hours
  ms -= hours * 3600000;
  const minutes = Math.floor(ms / 60000); // get minutes
  ms -= minutes * 60000;
  const secondes = Math.floor(ms / 1000); // get secondes
  if (hours) return `${hours}:${`0${minutes}`.slice(-2)}:${`0${secondes}`.slice(-2)}`;
  return `${minutes}:${`0${secondes}`.slice(-2)}`;
};

export const getSinceText = (start: Date) => {
  return getDateDifferenceText(start, new Date());
};

export const formatBytes = (bytes: number, decimals = 2) : string => {
  if (bytes === 0) return '0 Mo';
  
  const k = 1024;
  const sizes = ['o', 'Ko', 'Mo', 'Go', 'To', 'Po', 'Eo', 'Zo', 'Yo'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  
  return parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + ' ' + sizes[i];
}

export default {
  delay,
  generateRandomId,
  cssPropertiesToStyledComponent,
  enumContainsString,
  is24HourClockFormat,
  isMobilePlatform,
  isTouchEnabled,
  addToPathNameUrl
};

